import { ref, computed } from 'vue';

export const useOffsetLimitPagination = (pageSize: number) => {
  const limit = ref(pageSize);
  const page = ref(0);

  const offset = computed(() => page.value * limit.value);

  return { limit, page, offset };
};
